/** DEM CLINIC — цвета из логотипа */
export const BRAND = {
  navy: '#1e3a5f',
  navyDark: '#0f2744',
  navyDarker: '#0a1a2e',
  navyLight: '#2d5a87',
  green: '#48b47b',
  greenLight: '#5fc48a',
  greenDark: '#3da36d',
  greenMuted: '#e8f5ee',
  greenSoft: '#d4ebe0',
};

export const BRAND_CHART_PALETTE = [
  BRAND.navy,
  BRAND.green,
  BRAND.navyLight,
  BRAND.greenLight,
  '#6bb896',
];

export const GRADIENT_GREEN = `linear-gradient(135deg, ${BRAND.green} 0%, ${BRAND.greenDark} 100%)`;
export const GRADIENT_NAVY = `linear-gradient(135deg, ${BRAND.navy} 0%, ${BRAND.navyDark} 100%)`;
export const GRADIENT_NAVY_GREEN = `linear-gradient(135deg, ${BRAND.navy} 0%, ${BRAND.green} 100%)`;
export const GRADIENT_SOFT = `linear-gradient(135deg, ${BRAND.navyLight} 0%, ${BRAND.green} 100%)`;
export const GRADIENT_AMBER = `linear-gradient(135deg, #e8a838 0%, #d4881c 100%)`;

export const CHART_AXIS = '#7a8ba8';
export const CHART_GRID = 'rgba(30, 58, 95, 0.12)';

export function hexAlpha(hex, alpha) {
  const h = hex.replace('#', '');
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function apexBarFill(colorFrom, fadeAlpha = 0.28) {
  return {
    type: 'gradient',
    gradient: {
      type: 'vertical',
      shadeIntensity: 1,
      opacityFrom: 0.88,
      opacityTo: 0.95,
      colorStops: [
        [{ offset: 0, color: colorFrom, opacity: 1 }],
        [{ offset: 100, color: hexAlpha(colorFrom, fadeAlpha), opacity: 1 }],
      ],
    },
  };
}

export const apexGrid = {
  show: true,
  borderColor: CHART_GRID,
  yaxis: { lines: { show: false } },
  xaxis: { lines: { show: false } },
};

export const apexXaxisLabels = {
  style: { colors: CHART_AXIS, fontSize: '12px', fontWeight: '500' },
  axisBorder: { show: false },
  axisTicks: { show: false },
};
